"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = {
  ActionTypes: (0, _keyMirror.default)({
    GRADE_WEBSITE: null,
    GRADE_WEBSITE_POLLING: null,
    WEBSITE_GRADED: null,
    WEBSITE_GRADED_ERROR: null,
    STORE_CONTACT: null,
    DESKTOP_WEBSITE_PREVIEWED: null,
    DESKTOP_WEBSITE_PREVIEWED_ERROR: null,
    MOBILE_WEBSITE_PREVIEWED: null,
    MOBILE_WEBSITE_PREVIEWED_ERROR: null,
    EMAIL_SENDING: null,
    EMAIL_SENT: null,
    SHARE_MODAL_CLOSED: null,
    FETCH_PREVIEW_STARTED: null,
    RESULTS_PAGE_UNMOUNTED: null
  }),
  POLL_TIME_LIMIT: 120000
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/constants/AppConstants.js
// module id = 35
// module chunks = 0